import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaHeadset,
  FaTools,
  FaBullhorn,
  FaUserCheck,
  FaCalendarAlt,
  FaUsers,
  FaChartLine,
  FaRocket
} from 'react-icons/fa';
import logo from '../../Images/logo6.png';
import styles from './Navbar.module.css';

const ProductsDropdown = ({ isOpen, toggleDropdown }) => {
  const products = [
    { label: 'Chatbot', href: '/products/chatbot' },
    { label: 'Speech to Text', href: '/products/speech' },
    { label: 'Text to Speech', href: '/products/text' },
    { label: 'Voice AI Agents', href: '/products/voice' },
  ];

  return (
    <div className={styles.navItem}>
      <button
        className={`${styles.navLink} ${styles.dropdownToggle}`}
        onClick={() => toggleDropdown('products')}
        aria-expanded={isOpen}
      >
        Products
        <FaChevronDown className={`${styles.chevronIcon} ${isOpen ? styles.rotate : ''}`} />
      </button>

      <div className={`${styles.dropdown} ${isOpen ? styles.show : ''}`}>
        {products.map((item) => (
          <NavLink
            key={item.label}
            to={item.href}
            className={({ isActive }) =>
              `${styles.dropdownItem} ${isActive ? styles.active : ''}`
            }
            onClick={() => toggleDropdown('products')}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

const IndustriesDropdown = ({ isOpen, toggleDropdown }) => {
  const industries = [
    { label: 'Travel', href: '/travel-hospitality' },
    { label: 'Telecom', href: '/telecom' },
    { label: 'Retail', href: '/industries/retail' },
    { label: 'Real Estate', href: '/Real-Estate' },
    { label: 'Election', href: '/industries/election' },
    { label: 'Health', href: '/Health' },
    { label: 'Education', href: '/industries/education' },
    { label: 'Banking & Finance', href: '/Insurance' },
    { label: 'E-commerce', href: '/industries/e-commerce' },
    { label: 'Automobile', href: '/industries/Automobile' },
    { label: 'Logistic', href: '/Logistic' },
    { label: 'Bpo&Customer-Support', href: '/industries/BPO' },
  ];

  return (
    <div className={styles.navItem}>
      <button
        className={`${styles.navLink} ${styles.dropdownToggle}`}
        onClick={() => toggleDropdown('industries')}
        aria-expanded={isOpen}
      >
        Industries
        <FaChevronDown className={`${styles.chevronIcon} ${isOpen ? styles.rotate : ''}`} />
      </button>

      <div
        className={`${styles.dropdown} ${isOpen ? styles.show : ''} ${styles.industriesDropdown}`}
      >
        {industries.map((item) => (
          <NavLink
            key={item.label}
            to={item.href}
            className={({ isActive }) =>
              `${styles.dropdownItem} ${isActive ? styles.active : ''}`
            }
            onClick={() => toggleDropdown('industries')}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

const AIAgentsDropdown = ({ isOpen, toggleDropdown }) => {
  const agents = [
    {
      label: 'Customer Support', icon: <FaHeadset />, subItems: [
        { label: 'Live Chat Support', href: '/ai-support/live-chat' },
        { label: 'Ticket Resolution', href: '/ai-support/ticket-resolution' },
        { label: 'Customer Feedback', href: '/ai-support/feedback' },
      ],
    },
    {
      label: 'AI Tech Support', icon: <FaTools />, subItems: [
        { label: 'Technical Troubleshooting', href: '/ai-tech/troubleshooting' },
        { label: 'Software Assistance', href: '/ai-tech/software' },
        { label: 'Hardware Support', href: '/ai-tech/hardware' },
      ],
    },
    {
      label: 'AI Sales Agent', icon: <FaBullhorn />, subItems: [
        { label: 'Lead Qualification', href: '/ai-sales/lead-qualification' },
        { label: 'Sales Pitch Automation', href: '/ai-sales/pitch' },
        { label: 'Follow-Up Management', href: '/ai-sales/follow-up' },
      ],
    },
    {
      label: 'AI Interviewer', icon: <FaUserCheck />, subItems: [
        { label: 'Candidate Screening', href: '/ai-interviewer/screening' },
        { label: 'Interview Scheduling', href: '/ai-interviewer/scheduling' },
        { label: 'Assessment Analysis', href: '/ai-interviewer/assessment' },
      ],
    },
    {
      label: 'AI Booking Agent', icon: <FaCalendarAlt />, subItems: [
        { label: 'Appointment Booking', href: '/ai-booking/appointment' },
        { label: 'Reservation Management', href: '/ai-booking/reservation' },
        { label: 'Calendar Integration', href: '/ai-booking/calendar' },
      ],
    },
    {
      label: 'AI Recruiter', icon: <FaUsers />, subItems: [
        { label: 'Talent Sourcing', href: '/ai-recruiter/sourcing' },
        { label: 'Resume Screening', href: '/ai-recruiter/resume' },
        { label: 'Candidate Outreach', href: '/ai-recruiter/outreach' },
      ],
    },
    {
      label: 'AI Lead Agent', icon: <FaChartLine />, subItems: [
        { label: 'Lead Generation', href: '/ai-lead/generation' },
        { label: 'Lead Nurturing', href: '/ai-lead/nurturing' },
        { label: 'CRM Integration', href: '/ai-lead/crm' },
      ],
    },

    {
      label: 'Sales Automation', icon: <FaRocket />, subItems: [
        { label: 'Collection', href: '/sales-automation/collection' },
        { label: 'Sales And Marketing', href: '/sales-automation/salesmanagement' },
        { label: 'Customer-Support', href: '/sales-automation/customersupport' },
      ],
    },
  ];

  return (
    <div className={styles.navItem}>
      <button
        className={`${styles.navLink} ${styles.dropdownToggle}`}
        onClick={() => toggleDropdown('agents')}
        aria-expanded={isOpen}
        aria-controls="dropdown-agents"
      >
        Our AI Agents
        <FaChevronDown className={`${styles.chevronIcon} ${isOpen ? styles.rotate : ''}`} />
      </button>

      <div
        id="dropdown-agents"
        className={`${styles.dropdown} ${isOpen ? styles.show : ''} ${styles.AIAgentsDropdown}`}
      >
        {agents.map((item) => (
          <div key={item.label} className={styles.dropdownGroup}>
            <div className={styles.dropdownHeader}>
              {item.icon}
              <span>{item.label}</span>
            </div>
            {item.subItems.map((sub) => (
              <NavLink
                key={sub.label}
                to={sub.href}
                target="_blank"
                rel="noopener noreferrer"
                className={({ isActive }) => `${styles.dropdownItem} ${isActive ? styles.active : ''}`}
                onClick={() => toggleDropdown('agents')}
              >
                {sub.label}
              </NavLink>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const ResourcesDropdown = ({ isOpen, toggleDropdown }) => {
  const items = [
    { label: 'Help Center', href: '/help' },
    { label: 'FAQ\'s', href: '/faq' }, // Using existing /faq
    { label: 'Customer Support', href: '/customer-support' }, // Using existing /customer-support
    { label: 'Blog & Updates', href: '/blogs' },
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms-of-service' },
  ];

  return (
    <div className={styles.navItem}>
      <button
        className={`${styles.navLink} ${styles.dropdownToggle}`}
        onClick={() => toggleDropdown('resources')}
        aria-expanded={isOpen}
      >
        Resources
        <FaChevronDown className={`${styles.chevronIcon} ${isOpen ? styles.rotate : ''}`} />
      </button>

      <div className={`${styles.dropdown} ${isOpen ? styles.show : ''}`}>
        {items.map((item) => (
          <NavLink
            key={item.label}
            to={item.href}
            className={({ isActive }) => `${styles.dropdownItem} ${isActive ? styles.active : ''}`}
            onClick={() => toggleDropdown('resources')}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    products: false,
    industries: false,
    agents: false,
    aboutus: false,
    resources: false, // Added resources
  });
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRefs = useRef({});

  const toggleMobileMenu = () => setIsMobileMenuOpen(prev => !prev);

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => ({
      products: false,
      industries: false,
      agents: false,
      aboutus: false,
      resources: false,
      [menu]: !prev[menu],
    }));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!Object.values(dropdownRefs.current).some(ref => ref?.contains(e.target))) {
        setDropdownOpen({
          products: false,
          industries: false,
          agents: false,
          aboutus: false,
          resources: false
        });
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav className={`${styles.navbar} ${isHomePage ? styles.homeNavbar : ''}`}>
      {/* Logo */}
      <div className={styles.logo}>
        <img
          src={logo}
          alt="ToxBox Logo"
          className={styles.logoImg}
          onClick={() => navigate('/')}
        />
      </div>

      <div className={styles.navLinks}>
        <div className={styles.navItem} ref={el => dropdownRefs.current.products = el}>
          <ProductsDropdown
            isOpen={dropdownOpen.products}
            toggleDropdown={toggleDropdown}
          />
        </div>

        <div className={styles.navItem} ref={el => dropdownRefs.current.industries = el}>
          <IndustriesDropdown
            isOpen={dropdownOpen.industries}
            toggleDropdown={toggleDropdown}
          />
        </div>

        <div className={styles.navItem1} ref={el => dropdownRefs.current.agents = el}>
          <AIAgentsDropdown isOpen={dropdownOpen.agents} toggleDropdown={toggleDropdown} />
        </div>

        {/* New Links */}
        <NavLink to="/features" className={styles.navLink} style={{ margin: '0 15px' }}>Features</NavLink>
        <NavLink to="/pricing" className={styles.navLink} style={{ margin: '0 15px' }}>Pricing</NavLink>

        <div className={styles.navItem} ref={el => dropdownRefs.current.resources = el}>
          <ResourcesDropdown isOpen={dropdownOpen.resources} toggleDropdown={toggleDropdown} />
        </div>

        {/* 
        <div className={styles.navItem2} ref={el => dropdownRefs.current.aboutus = el}>
          <AboutUsDropdown isOpen={dropdownOpen.aboutus} toggleDropdown={toggleDropdown} />
        </div> 
        */}

        <Link to="/demo-form" className={styles.demoBtn}>Book Demo</Link>
        <Link to="/login" className={styles.signInBtn}>Sign In</Link>
      </div>

      {/* Mobile Menu Button */}
      <button
        className={styles.mobileMenuBtn}
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Mobile Fullscreen Menu */}
      <div className={`${styles.mobileMenu} ${isMobileMenuOpen ? styles.mobileMenuOpen : ''}`}>
        <div className={styles.mobileDropdown}>
          <span className={styles.mobileLink} onClick={() => navigate('/features')}>Features</span>
          <span className={styles.mobileLink} onClick={() => navigate('/pricing')}>Pricing</span>
        </div>
        <div className={styles.mobileDropdown}>
          <AIAgentsDropdown isOpen={dropdownOpen.agents} toggleDropdown={toggleDropdown} />
        </div>
        <div className={styles.mobileDropdown}>
          <ResourcesDropdown isOpen={dropdownOpen.resources} toggleDropdown={toggleDropdown} />
        </div>

        <Link to="/demo-form" className={styles.demoBtn} onClick={toggleMobileMenu}>
          Book Demo
        </Link>
        <Link to="/login" className={styles.signInBtn} onClick={toggleMobileMenu}>
          Sign In
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;